/** 模块层级的规范地址；前后端共用，保证播放资源回退与页面路由一致。 */
export const PATHS = {
  home: "/",
  english: "/english",
  textbook2a: "/english/textbook/2a",
  aesop: "/english/aesop",
  player: "/english/aesop/player",
  raz: "/english/raz",
  razA: "/english/raz/a",
  razAnnotate: "/english/raz/a/annotate",
  razReader: "/english/raz/a/reader",
  chinese: "/chinese",
  math: "/math",
} as const;

export function canonicalPath(path: string): string {
  const normalized = path.replace(/\/+$/, "") || "/";
  if (normalized === "/aesop") return PATHS.aesop;
  if (normalized === "/player" || normalized === "/player.html") return PATHS.player;
  return normalized;
}

export function playerUrl(id: string): string {
  return `${PATHS.player}?id=${encodeURIComponent(id)}`;
}

/** SWF 相对资源会落到播放页所在目录，剥掉模块路径后还原课程内文件名。 */
export function storyAssetRelativePath(pathname: string, refererPath: string): string {
  const modulePrefix = PATHS.aesop + "/";
  if (canonicalPath(refererPath) === PATHS.player && pathname.startsWith(modulePrefix)) {
    return pathname.slice(modulePrefix.length);
  }
  return pathname.replace(/^\//, "");
}
